import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'aos/dist/aos.css';
import AOS from 'aos';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaAngleRight,
} from 'react-icons/fa';

const Footer = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out',
      disable: 'mobile',
    });
  }, []);

  const quickLinks = [
    { to: '/', label: 'Home' },
    { to: '/who-we-are', label: 'About Us' },
    { to: '/our-services', label: 'Services & Products' },
    { to: '/blogs', label: 'Blogs' },
    { to: '/careers', label: 'Careers & Benefits' },
    { to: '/terms', label: 'Terms & Conditions' },
    { to: '/contact-us', label: 'Contact Us' },
  ];

  const services = [
    { to: '/custom-software-development', label: 'Software Development Services' },
    { to: '/it-support-services', label: 'IT Consulting & Managed Services' },
    { to: '/cloud-service-providers', label: 'Cloud & Beyonds' },
    { to: '/bpo-services', label: 'Business Process Services' },
    { to: '/data-analytics-services', label: 'AI & Data Analytics Solutions' },
    { to: '/digital-marketing-services', label: 'Digital Marketing & Experience Design' },
    { to: '/ui-ux-design-services', label: 'UI/UX-Design-Services' },
    { to: '/cybersecurity-services', label: 'Cybersecurity-Services' },
  ];

  const socialLinks = [
    { Icon: FaFacebookF, url: 'https://www.facebook.com/profile.php?id=61576099186187' },
    { Icon: FaInstagram, url: 'https://www.instagram.com/securxpert' },
    { Icon: FaLinkedinIn, url: 'https://www.linkedin.com/company/securxpert-technologies-pvt-ltd/posts/?feedView=all' },
    { Icon: FaYoutube, url: 'https://www.youtube.com/@SecurXpert' },
  ];

  const BG_COLOR = 'bg-gray-100';
  const TEXT_COLOR = 'text-gray-700';
  const HEADING_COLOR = 'text-gray-900';
  const ACCENT_COLOR = 'text-indigo-600';

  return (
    <footer className={`${BG_COLOR} ${TEXT_COLOR} py-12 sm:py-16 font-sans relative`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
          {/* Column 1: Logo, We Are Reviewed, Guarantee Text, Social Links */}
          <div className="lg:col-span-1" data-aos="fade-up" data-aos-delay="100">
            <div className="mb-4">
              <img
                src="/img/LOGO.png"
                alt="SecurXpert Technologies Logo"
                className="h-10 object-contain"
              />
            </div>

            {/* NEW: We Are Reviewed + scrolling badges + ISO block */}
            <div className="mb-6">
              <h3 className="font-extrabold text-sm uppercase mb-3 text-gray-900">
                We Are Reviewed
              </h3>

              {/* Scrolling logos */}
              <div className="scrolling-container mb-3">
                <div className="scrolling-content">
                  <a
                    href="https://www.goodfirms.co/company/securxperts-technologies-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top Developers"
                      src="/img/goodfirms PNG.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                  <a
                    href="https://clutch.co/profile/securxperts-technologies?_gl=1*g4u0ik*_gcl_au*MTIxNzAyNTY2MS4xNzQ5NTQ4ODU3LjIzNDk1NjUzMy4xNzQ5NzA4NTU1LjE3NDk3MDg1NTQ.*FPAU*MTIxNzAyNTY2MS4xNzQ5NTQ4ODU3*_ga*OTg4OTA1MzM3LjE3NDk1NDg4NTc.*_ga_D0WFGX8X3V*czE3NDk3Mjk0NDgkbzMkZzEkdDE3NDk3MzEwNjIkajQyJGwwJGgxNjYwOTgzODk.*_fplc*MG1OTWslMkZQNnNtS3cwU3pjUUZBU3JZSjV6MWU4MWhDakZBRGVZb29BdDhjbGh0NmQ1Nm1mZmpiZEVjRXZBWUp1M3dlZXlJRiUyQk9CMHYxR2xSb1BGaUJ0QmklMkJOYVFjSjQ4Sjg2ODZoRHFEd1k2RnFlTXRTSXB0YTQxb3gzJTJGT3clM0QlM0Q."
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top App Companies"
                      src="/img/clutch PNG.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                  <a
                    href="https://www.softwareworld.co"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top Rated SoftwareWorld"
                      src="/img/Softwareworld PNG.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                  <a
                    href="https://businessfirms.co/company/securxpert-technologies-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top Rated SoftwareWorld"
                      src="/img/businessfirms.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>

                  {/* Duplicated for seamless loop */}
                  <a
                    href="https://www.goodfirms.co/company/securxperts-technologies-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top Developers"
                      src="/img/goodfirms PNG.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                  <a
                    href="https://clutch.co/profile/securxperts-technologies?_gl=1*g4u0ik*_gcl_au*MTIxNzAyNTY2MS4xNzQ5NTQ4ODU3LjIzNDk1NjUzMy4xNzQ5NzA4NTU1LjE3NDk3MDg1NTQ.*FPAU*MTIxNzAyNTY2MS4xNzQ5NTQ4ODU3*_ga*OTg4OTA1MzM3LjE3NDk1NDg4NTc.*_ga_D0WFGX8X3V*czE3NDk3Mjk0NDgkbzMkZzEkdDE3NDk3MzEwNjIkajQyJGwwJGgxNjYwOTgzODk.*_fplc*MG1OTWslMkZQNnNtS3cwU3pjUUZBU3JZSjV6MWU4MWhDakZBRGVZb29BdDhjbGh0NmQ1Nm1mZmpiZEVjRXZBWUp1M3dlZXlJRiUyQk9CMHYxR2xSb1BGaUJ0QmklMkJOYVFjSjQ4Sjg2ODZoRHFEd1k2RnFlTXRTSXB0YTQxb3gzJTJGT3clM0QlM0Q."
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top App Companies"
                      src="/img/clutch PNG.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                  <a
                    href="https://www.softwareworld.co"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top Rated SoftwareWorld"
                      src="/img/Softwareworld PNG.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                  <a
                    href="https://businessfirms.co/company/securxpert-technologies-pvt-ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Top Rated SoftwareWorld"
                      src="/img/businessfirms.png"
                      className="h-16 rounded-2xl mr-5"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Existing guarantee line (kept as requested) */}
            <p className="text-sm my-4 text-gray-600 leading-relaxed max-w-xs">
              100% Service Quality Certified Agency Satisfaction Guarantee
            </p>

            {/* Social Links */}
            <div className="flex space-x-3 mt-6">
              {socialLinks.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 ${TEXT_COLOR} hover:bg-indigo-600 hover:border-indigo-600 hover:text-white transition duration-300`}
                  aria-label={`Link to ${item.Icon.name}`}
                >
                  <item.Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div
            className="sm:col-span-1 lg:col-span-1"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h3
              className={`font-extrabold text-sm uppercase mb-8 ${HEADING_COLOR} relative footer-heading`}
            >
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className={`flex items-center text-sm ${TEXT_COLOR} hover:${ACCENT_COLOR} transition-colors duration-200`}
                  >
                    <FaAngleRight
                      className={`w-3 h-3 mr-2 ${ACCENT_COLOR} flex-shrink-0`}
                    />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div
            className="sm:col-span-1 lg:col-span-1"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h3
              className={`font-extrabold text-sm uppercase mb-8 ${HEADING_COLOR} relative footer-heading`}
            >
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.to}
                    className={`flex items-start text-sm ${TEXT_COLOR} hover:${ACCENT_COLOR} transition-colors duration-200`}
                  >
                    <FaAngleRight
                      className={`w-3 h-3 mr-2 mt-1 ${ACCENT_COLOR} flex-shrink-0`}
                    />
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div
            className="sm:col-span-2 lg:col-span-1"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <h3
              className={`font-extrabold text-sm uppercase mb-8 ${HEADING_COLOR} relative footer-heading`}
            >
              Contact Us
            </h3>

            <div className="space-y-6">
              <div className="flex items-start">
                <div
                  className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}
                >
                  <FaPhoneAlt className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">
                    Phone Number
                  </span>
                  <a
                    href="tel:+917933256679"
                    className={`text-sm font-bold ${HEADING_COLOR} hover:${ACCENT_COLOR}`}
                  >
                    +91 79932 56679
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div
                  className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}
                >
                  <FaEnvelope className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">
                    Email Address
                  </span>
                  <a
                    href="mailto:info@SecurXperts.com"
                    className={`text-sm font-bold ${HEADING_COLOR} hover:${ACCENT_COLOR}`}
                  >
                    info@SecurXperts.com
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div
                  className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}
                >
                  <FaMapMarkerAlt className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">
                    Office Location
                  </span>
                  <p className="text-sm font-medium leading-relaxed text-gray-600">
                    5th Floor, Krishna Towers (Square Hub), 100 Feet Rd, Madhapur,
                    Hyderabad, Telangana 500081
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 sm:mt-16 pt-6 border-t border-gray-300 text-center">
          <p className="text-sm font-light text-gray-500">
            &copy; {new Date().getFullYear()} SecurXpert Technologies. All rights
            reserved.
          </p>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
  .scrolling-container {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
  }

  .scrolling-content {
    display: inline-flex;
    animation: scroll-right-to-left 10s linear infinite;
    align-items: center;
  }

  .scrolling-content a {
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    /* CARD SIZE + LOOK LIKE THE IMAGE */
    background: #ffffff;
    border-radius: 24px;
    height: 96px;         /* same visual height as screenshot */
    min-width: 210px;     /* same width feel */
    padding: 0 24px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  }

  .scrolling-content a img {
    max-height: 64px;     /* keeps logo inside nicely */
    width: auto;
    object-fit: contain;
    display: block;
  }

  @keyframes scroll-right-to-left {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  .scrolling-content:hover {
    animation-play-state: paused;
  }
`}</style>



    </footer>
  );
};

export default Footer;
